/**
 * Lead event category type object model.
 */
export default class LeadEventCategoryType {
	constructor(public readonly id: string) {}

	/**
	 * Convert string to LeadEventTypeObject.
	 * @param {string} string
	 * @return {LeadEventTypeObject}
	 */
	public static fromString(string: string): LeadEventCategoryType {
		return new LeadEventCategoryType(string)
	}

	public static getAllCategories(): LeadEventCategoryType[] {
		return [
			LeadEventCategoryType.fromString("Contact"),
			LeadEventCategoryType.fromString("Status"),
			LeadEventCategoryType.fromString("Notes"),
			LeadEventCategoryType.fromString("Reminders"),
			LeadEventCategoryType.fromString("Appointments"),
			LeadEventCategoryType.fromString("Surveys"),
			LeadEventCategoryType.fromString("Files"),
			LeadEventCategoryType.fromString("Quotes"),
			LeadEventCategoryType.fromString("Lead Updates")
		]
	}

	getLabel() {
		return this.id;
	}
}